import React, { useState } from 'react';
import { deleteAdminLeadRequest, updateAdminLeadRequestStatus } from '../../../shared/api/lead-requests.services';
import toast from '../../../shared/lib/toast';
import { translateStatus, getStatusColor } from '../../../shared/lib/statusTranslate';
import './leadRequestItem.scss';

const SOURCE_LABELS = {
  website: 'Форма на сайті',
  'website-assessment': 'Опитування на головній',
};

const LeadRequestItem = ({ request, onRefresh }) => {
  const [isDeleted, setIsDeleted] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  if (isDeleted) return null;

  const name = request?.name || 'N/A';
  const phone = request?.phone || 'N/A';
  const formType = request?.formType === 'contact' ? 'Контакт' : 'План розвитку';
  // Найголовніше в заявці — що саме людина написала (а для опитування з
  // головної тут лежать її відповіді). Досі цього не було видно ніде.
  const message = request?.message || '';
  const topic = request?.topic || '';
  const email = request?.email || '';
  const childAge = request?.childAge || '';
  const source = SOURCE_LABELS[request?.source] || request?.source || '';
  const pageUrl = request?.pageUrl || '';
  const hasDetails = Boolean(message || topic || email || childAge || source || pageUrl);
  const statusValue = request?.status || 'received';
  const statusLabel = translateStatus(statusValue);
  const createdAt = new Date(request?.createdAt).toLocaleDateString('uk-UA');

  const handleDelete = async () => {
    if (window.confirm('Ви впевнені, що хочете видалити цю заявку?')) {
      try {
        const response = await deleteAdminLeadRequest(request?.id);
        if (response?.ok || !response?.error) {
          setIsDeleted(true);
          toast.success('Заявку успішно видалено!');
          if (onRefresh) onRefresh();
        } else {
          toast.error(response?.message || 'Помилка при видаленні заявки.');
        }
      } catch (err) {
        toast.error('Помилка при видаленні заявки.');
      }
    }
  };

  const handleStatusChange = async (newStatus) => {
    if (isUpdating) return;
    setIsUpdating(true);
    try {
      const response = await updateAdminLeadRequestStatus(request?.id, newStatus);
      if (!response?.error) {
        toast.success('Статус заявки оновлено!');
        if (onRefresh) onRefresh();
      } else {
        toast.error(response?.message || 'Помилка при оновленні статусу.');
      }
    } catch (err) {
      toast.error('Помилка при оновленні статусу.');
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div className='lead-request-item team-grid'>
      <div className="lead-request-item__info">
        <div className="lead-request-item__info-txt">
          <p className='lead-name'>{name}</p>
          <p className='lead-phone'>{phone}</p>
          {email && <p className='lead-phone'>{email}</p>}
        </div>
      </div>

      <div className="lead-request-item__info">
        <div className="lead-request-item__info-txt">
          <p className='lead-form-type'>{formType}</p>
          <p className='lead-date'>{createdAt}</p>
        </div>
      </div>

      <div className="lead-request-item__status">
        <select
          className='status-select'
          value={statusValue}
          onChange={(e) => handleStatusChange(e.target.value)}
          disabled={isUpdating}
        >
          <option value="received">{translateStatus('received')}</option>
          <option value="contacted">{translateStatus('contacted')}</option>
          <option value="closed">{translateStatus('closed')}</option>
        </select>
      </div>

      <div className="lead-request-item__func">
        {hasDetails && (
          <button
            type="button"
            className='func-rewrite'
            onClick={() => setIsOpen((prev) => !prev)}
          >
            {isOpen ? 'Згорнути' : 'Деталі'}
          </button>
        )}
        <button
          type="button"
          className='func-delete'
          onClick={handleDelete}
          disabled={isUpdating}
        >
          Видалити
        </button>
      </div>

      {isOpen && hasDetails && (
        <div className="lead-request-item__details">
          {source && <p><span>Звідки:</span> {source}</p>}
          {topic && <p><span>Тема:</span> {topic}</p>}
          {childAge && <p><span>Вік дитини:</span> {childAge}</p>}
          {message && (
            <div className="lead-request-item__message">
              <span>Повідомлення:</span>
              <span className="lead-request-item__message-text">{message}</span>
            </div>
          )}
          {pageUrl && (
            <p>
              <span>Сторінка:</span>{' '}
              <a href={pageUrl} target="_blank" rel="noreferrer">{pageUrl}</a>
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default LeadRequestItem;
